// pirate array
const pirates = [
  {
    name: "John Rackham",
    image: "avatar.png",
    description:
      "Rackham deposed Charles Vane from his position as captain of the sloop Ranger, then cruised the Leeward Islands, Jamaica Channel and Windward Passage. He accepted a pardon in 1719 and moved to New Providence, where he met Anne Bonny. He returned to piracy in 1720 by stealing a British sloop and Anne joined him.",
    year: 1720,
    weapon: "Sword",
    vessel: "Bounty",
  },
  {
    name: "Donald Trump",
    image: "avatar.png",
    description:
      "Trump was born and raised in the New York City borough of Queens and received an economics degree from the Wharton School. He took charge of his family's real estate business in 1971, renamed it The Trump Organization, and expanded it from Queens and Brooklyn into Manhattan. ",
    year: 1800,
    weapon: "Twitter",
    vessel: "Trump Airlines",
  },
  {
    name: "Blackbeard",
    image: "avatar.png",
    description:
      "Edward Teach, better known as Blackbeard, was an English pirate who operated around the West Indies and the eastern coast of Britain's North American colonies. Little is known about his early life, but he may have been a sailor on privateer ships during Queen Anne's War before settling in the Bahamas",
    year: 1684,
    weapon: "Sword",
    vessel: "Revenge",
  },
  {
    name: "Jean Lafitte",
    image: "avatar.png",
    description:
      "A rich Barbadian land owner, turned pirate solely in search of adventure. Bonnet captained a 10-gun sloop, named the Revenge, raiding ships off the Virginia coast in 1717. He was caught and hanged in 1718",
    year: 1718,
    weapon: "Sword",
    vessel: "Stealth",
  },
];

export default pirates;
